import React, { useEffect, useState } from "react";
import { useError } from "./ErrorContext";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";

const GlobalErrorHandler = () => {
  const { error, clearError } = useError();
  const [errorQueue, setErrorQueue] = useState([]);

  useEffect(() => {
    if (error) {
      setErrorQueue((prev) => {
        const errorMessage = error?.response?.data?.messages?.[0] || error?.message || error?.AxiosError?.message;
        return prev.includes(errorMessage) ? prev : [...prev, errorMessage]; // Avoid duplicates
      });
    }
  }, [error]);

  const handleClose = (errorMessage) => {
    setErrorQueue((prev) => prev.filter((msg) => msg !== errorMessage)); 
  };

  return (
    <>
      {errorQueue.map((errorMessage, index) => (
        <Snackbar
          key={index}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={true}
          autoHideDuration={2000}
          onClose={() => handleClose(errorMessage)}
        >
          <SnackbarContent
            style={{ backgroundColor: "red", color: "white", marginBottom: "8px", fontSize: "1rem" }}
            message={`Error: ${errorMessage}`}
          />
        </Snackbar>
      ))}
    </>
  );
};

export default GlobalErrorHandler;
